<template>
	<div class="page">
		<Tip :title="title" style="margin-bottom: 10px;" />
		<TopTab :list='tabList' :tabIndex='tabIndex' @tabClick="submitForm" />
		<div class="from_div">
			<!--基础信息-->
			<el-form ref="baseForm" :model="baseForm" :rules="rules" v-if="tabIndex == 0" label-position="right" label-width="100px">
				<el-form-item label="商品名称：" prop="good_name">
					<el-input v-model="baseForm.good_name" placeholder="请输入内容" clearable style="max-width: 80%;" />
				</el-form-item>
				<el-form-item label="商品别名：" prop="good_alias">
					<el-input v-model="baseForm.good_alias" placeholder="请输入内容" clearable style="max-width: 80%;" />
				</el-form-item>
                <el-form-item label="商品类型：" prop="good_type">
					<el-select v-model="baseForm.good_type" filterable clearable placeholder="请选择">
                        <el-option label="标准商品" :value="1" />
                        <!-- <el-option label="虚拟商品" :value="2" />
                        <el-option label="技能服务" :value="3" /> -->
                        <el-option label="定制商品" :value="4" />
                        <el-option label="礼品"     :value="5" />
                        <el-option label="赠品"     :value="6" />
                    </el-select>
				</el-form-item>
                
				<el-form-item label="品牌分类：" style="margin-bottom:0" prop="good_brand">
					<div class="add_div" v-for="(item,index) in baseForm.good_brand">
						<div class="item_div">
							<el-select class="select" v-model="item[0]" filterable clearable placeholder="一级品牌" @change="addToBrand(item[0],index)">
								<el-option :disabled="item.children.length == 0" v-for="item in goodBrandList" :key="item.cate_id" :label="item.cate_name" :value="item.cate_id" />
							</el-select>
							<el-select v-if="item[1] != null" class="select" v-model="item[1]" filterable clearable multiple collapse-tags placeholder="二级品牌">
								<el-option v-for="item in brandChildren[index]" :key="item.cate_id" :label="item.cate_name" :value="item.cate_id" />
							</el-select>
							<el-button type="primary" plain @click="addItem(index+1)">添加</el-button>
							<el-button v-if="index > 0" type="danger" plain @click="deleteItem(index)">删除</el-button>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="商品分类：" prop="good_cate">
					<el-select class="select" v-model="baseForm.good_cate[0]" filterable clearable placeholder="一级分类列表" @change="addToCate">
						<el-option :disabled="item.children.length == 0" v-for="item in goodCateList" :key="item.cate_id" :label="item.cate_name" :value="item.cate_id" />
					</el-select>
					<el-select v-if="baseForm.good_cate[1] != null" v-model="baseForm.good_cate[1]" filterable clearable multiple placeholder="二级分类列表" @change="cateChildrenClick" style="width: 300px;"> <el-option v-for="item in cateChildren" :key="item.cate_id" :label="item.cate_name" :value="item.cate_id" />
					</el-select>
				</el-form-item>
				<el-form-item v-if="tagList.length > 0" label="商品标签：" prop="tag_ids">
					<el-checkbox-group v-model="baseForm.tag_ids">
						<el-checkbox v-for="item in tagList" :label="item.tag_id" name="type">{{item.tag_name}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
                <el-form-item label="发货仓库：" prop="warehouse_id">
					<el-select v-model="baseForm.warehouse_id" filterable clearable placeholder="请选择">
                        <el-option :label="item.name" :value="item.id" v-for="item in logistics" :key="item.id"></el-option>
                    </el-select>
				</el-form-item>
				<el-form-item label="简要描述：" prop="good_desc">
					<el-input v-model="baseForm.good_desc" placeholder="请输入内容" clearable style="max-width: 80%;" />
				</el-form-item>
				<el-form-item label="销售承诺：" prop="promise">
					<el-checkbox-group v-model="baseForm.promise">
						<el-checkbox v-for="item in promiseList" :label="item.lable" name="type">{{item.value}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
			<!--图片信息-->
			<el-form ref="imgForm" :model="imgForm" :rules="rules" v-if="tabIndex == 1" label-position="left" label-width="100px">
				<el-form-item label="商品主图：" prop="cover_img" style="margin-bottom: 0;">
					<div class="row">
						<multiUpload :type='0' :limitImg='1' :noneBtnImg='coverImgList.length > 0' :fileList="coverImgList" @saveImg="saveImg" @delImg="delImg" />
						<span class="span">请上传图片(800-800px)</span>
					</div>
				</el-form-item>
				<el-form-item label="轮播图：" prop="wheel_img" style="margin-bottom: 0;">
					<span class="span">最多6张图片，支持选择多张图上传，请上传图片(800-800px)</span>
					<multiUpload :type='1' :limitImg='6' :noneBtnImg='wheelImgList.length > 6' :fileList="wheelImgList" :multiple="true" @saveImg="saveImg" @delImg="delImg" />
				</el-form-item>
				<el-form-item label="商品视频：" prop="video_type" style="margin-bottom: 0;">
					<el-radio-group v-model="imgForm.video_type">
						<el-radio :label="2">视频音频外链</el-radio>
						<el-input class="input_" v-model="imgForm.video_url" placeholder="注意链接中包含 http://" clearable />
						<div class="row" style="margin-top: 20px;">
							<el-radio :label="1">上传视频音频</el-radio>
							<fileUpload :fileUrl="imgForm.video_url_upload" @saveFile="saveFile" />
							<span class="span">文件限50M以内 mp4、avi、mp3格式</span>
						</div>
					</el-radio-group>
					<el-checkbox-group v-model="imgForm.video_buyed">
						<el-checkbox :true-label="1" :false-label="0">本视频音频商品，必须订单购买后才能播放观看</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="详情图片：" prop="detail_img" style="margin-bottom: 0;">
					<span class="span">最多6张图片，支持选择多张图上传，请上传图片(800-800px)</span>
					<multiUpload :type='2' :limitImg='6' :noneBtnImg='detailImgList.length > 6' :fileList="detailImgList" @saveImg="saveImg" @delImg="delImg" />
				</el-form-item>
				<el-form-item label="详情内容：">
					<quill-editor ref="text" v-model="baseForm.content" class="editor" :options="{}" style="width: 90%;height: 300px;margin-bottom: 50px;"/>
				</el-form-item>
			</el-form>
			<!--规格信息-->
			<el-form ref="skuForm" :model="skuForm" :rules="rules" v-if="tabIndex == 2" label-position="left" label-width="100px">
				<el-form-item label="商品规格：" class="is-required" style="margin-bottom:0">
					<el-scrollbar style="max-width: 100%;">
                        <EditSpec :formData='skuForm' />
                    </el-scrollbar>
				</el-form-item>
				<el-form-item label="商品限购：">
					<span class="span">起购量</span>
					<el-input class="input_s" v-model="skuForm.buy_min" placeholder="1" clearable />
					<span class="span" style="margin-left: 85px;">最大限购</span>
					<el-input class="input_s" v-model="skuForm.buy_max" placeholder="1000" clearable />
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submitForm(tabIndex+1)">{{tabIndex == 2 ? '保存':'下一步'}}</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import multiUpload from "../../../components/multiUpload/multiUpload.vue"
	import fileUpload from "../../../components/fileUpload/fileUpload.vue"
	import TopTab from "../../../components/TopTab/TopTab.vue"
	import EditSpec from "../../../components/EditSpec/EditSpec.vue"
	import { goodsCateLists, goodAdd, goodEdit, goodDetail, setJd } from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			multiUpload,
			fileUpload,
			TopTab,
			EditSpec
		},
		props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				title: '编辑新增',
				coverImgList: [], //商品主图
				wheelImgList: [], //轮播图
				detailImgList: [], //详情图
				skuImgList: [{}], //规格图
				tabIndex: 0,
				tabList: ['基础信息', '图片信息', '规格信息'],
				goodBrandList: [],
				brandChildren: [],
				goodCateList: [],
				cateChildren: [],
				tagList: [],
				promiseList: [{
					lable: 'refund7',
					value: '7天无理由退换货'
				}, {
					lable: 'certified',
					value: '正品保障'
				}, {
					lable: 'expressfree',
					value: '快递包邮'
				}],
				baseForm: { //基础信息
					good_source: '1', //商品来源1=平台商品,2=商家商品,3=供应链,4=供应商
					good_type: 1, //商品性质1=标准商品,2=虚拟商品,3=技能服务
					good_name: '', //商品名称
					good_alias: '', //商品别名
					good_brand: [
						[]
					], //品牌分类列表
					good_cate: [], //商品分类列表
                    warehouse_id: '',
					good_desc: '', //简要描述
					tag_ids: [], //标签
					promise: [], //销售承诺
					content : ''
				},

				imgForm: { //图片信息
					cover_img: '', //商品主图
					wheel_img: [], //轮播图
					video_type: '', //视频类型
					video_url: '', //外链视频路径
					video_url_upload: '', //本地视频路径
					video_buyed: '', //购买后才能看视频
					detail_img: [], //详情图片
					content: '1' //图文详情
				},
				skuForm: { //规格信息
					buy_min: '', //最低购买量
					buy_max: '', //最高购买量
					spec_name1: '默认', //规格一
					spec_name2: '', //规格二
					skus: [{
						skuImgList:[],
						cover_img: '', //规格图片
						spec_val1: '', //规格一
						spec_val2: '', //规格二
						unit_quatity: '', //单位数量
						cost_price: '', //成本价
						sale_price: '', //销售价
						crossed_price: '', //划线价
						brcode: '', //条形码
						stock: '', //库存
						tax_rate: '', //税率
						com_buy: [{
							user_type: [], //组合购
							options: [], //账户状态
							money: '' //支付金额
						}]
					}]
				},
				rules: {
					good_name: [{
						required: true,
						message: '请输入商品名称',
						trigger: 'blur'
					}],
					good_cate: [{
						required: true,
						message: '请选中商品分类',
						trigger: 'blur'
					}],
					cover_img: [{
						required: true,
						message: '请上传商品主图',
						trigger: 'blur'
					}],
                    wheel_img: [{
						required: true,
						message: '请上传轮播图',
						trigger: 'blur'
					}],
				},
				formName: ['baseForm', 'imgForm', 'skuForm'],
                logistics: [],
			}
		},
		mounted() {
            this.getSetJd();
			if (this.type != -1) {
				//详情编辑
                this.title = '编辑';
				this.baseForm.good_id = this.type;
				this.getGoodsDetail();
			} else {
                this.title = '新增';
				this.getGoodsCateList();
			}
		},
		methods: {
            getSetJd(){
                setJd('get').then(res => {
                    if (res.code != 0) {
                        return this.$message.error(res.msg);
                    }
                    this.logistics = res.data.jd_accounts.filter(item => item.state == 1);
                }).catch(err => {});
            },
			getGoodsDetail() {
				goodDetail({
					good_id: this.baseForm.good_id
				}).then(res => {
					if (res.code == 0) {
						//主图
						if (res.data.cover_img != '') {
							this.coverImgList.push({
								url: res.data.cover_img
							})
						}
						//轮播图
						if (res.data.wheel_img.length > 0) {
							res.data.wheel_img.forEach((item, index) => {
								this.wheelImgList.push({
									url: item
								})
							})
						}
						//详情图
						if (res.data.detail_img.length > 0) {
							res.data.detail_img.forEach((item, index) => {
								this.detailImgList.push({
									url: item
								})
							})
						}
						//规格图
						if (res.data.skus.length > 0) {
							res.data.skus.forEach((item, index) => {
								item.skuImgList = [{
									url: item.cover_img
								}]
							})
						}
						for (var key in res.data) {
							if (key != 'good_cate' && key != 'good_brand' && key != 'tags') {
								//基础信息
								if (this.baseForm.hasOwnProperty(key)) {
									this.baseForm[key] = res.data[key];
								}
								//图片信息
								if (this.imgForm.hasOwnProperty(key)) {
									this.imgForm[key] = res.data[key];
								}
								//规格信息
								if (this.skuForm.hasOwnProperty(key)) {
									this.skuForm[key] = res.data[key];
								}
							}
						}
						this.dataPro(res.data.good_brand, res.data.good_cate, res.data.tag_ids);
						this.getGoodsCateList();
					}
				}).catch(err => {})
			},

			//品牌分类&商品分类&商品标签数据处理
			dataPro(brandList, cateList, tag_ids) {
				//品牌分类
				let brandResult = [];
                if(brandList.length){
                    for (let i = 0; i < brandList.length; i++) {
                        let item = brandList[i];
                        let existingGroup = brandResult.find(group => group[0] === item.brand_id1);
                        if (existingGroup) {
                            existingGroup[1].push(item.brand_id2);
                        } else {
                            brandResult.push([item.brand_id1, [item.brand_id2]]);
                        }
                    }
                }else{
                    brandResult.push([]);
                }
				this.baseForm.good_brand = brandResult;
				//商品分类
				let cateResult = [];
				cateList.forEach(item => {
					if (item.cate_id1 === cateResult[0]) {
						cateResult[1].push(item.cate_id2);
					} else {
						cateResult = [item.cate_id1, [item.cate_id2]];
					}
				});
				this.baseForm.good_cate = cateResult;
				//商品标签
				this.baseForm.tag_ids = tag_ids.slice(1, -1).split("-").map(Number);
                this.baseForm.warehouse_id = this.baseForm.warehouse_id || '';
			},

			//获取分类列表
			getGoodsCateList() {
				//品牌分类
				goodsCateLists({
					cate_type: '3'
				}).then(res => {
					if (res.code == 0) {
						this.goodBrandList = res.data
						if (this.baseForm.good_brand.length > 0) {
							this.baseForm.good_brand.forEach((items, index) => {
								var key = this.goodBrandList.findIndex(item => item.cate_id == items[0]);
								this.brandChildren[index] = this.goodBrandList[key].children;
							})
						}
					}
				}).catch(err => {})

				//商品分类
				goodsCateLists({
					cate_type: '1'
				}).then(res => {
					if (res.code == 0) {
						this.goodCateList = res.data
						if (this.baseForm.good_cate.length > 0) {
							this.baseForm.good_cate.forEach((items, index) => {
								var key = this.goodCateList.findIndex(item => item.cate_id == items);
								this.cateChildren = this.goodCateList[key].children;
								this.cateChildrenClick();
							})
						}
					}
				}).catch(err => {})
			},

			//品牌一级分类
			addToBrand(itemId, index) {
				if (itemId == '') {
					this.baseForm.good_brand[index][1] = null
				} else {
					this.baseForm.good_brand[index][1] = '';
					var key = this.goodBrandList.findIndex(item => item.cate_id == itemId);
					if (this.goodBrandList[key].children.length > 0) {
						this.brandChildren[index] = this.goodBrandList[key].children;
					} else {
						this.baseForm.good_brand[index][1] = null;
					}
				}
			},

			//添加品牌分类条目
			addItem(index) {
				this.baseForm.good_brand.splice(index, 0, [])
			},

			//移除品牌分类条目
			deleteItem(index) {
				this.baseForm.good_brand.splice(index, 1)
			},

			//商品一级分类
			addToCate(itemId) {
				if (itemId == '') {
					this.baseForm.good_cate[1] = null
				} else {
					this.baseForm.good_cate[1] = ''
					var key = this.goodCateList.findIndex(item => item.cate_id == itemId);
					if (this.goodCateList[key].children.length > 0) {
						this.cateChildren = this.goodCateList[key].children;
					} else {
						this.baseForm.good_cate[1] = null
					}
				}
				this.tagList = [];
				this.baseForm.tag_ids = [];
			},

			//商品二级分类
			cateChildrenClick() {
				if (this.baseForm.good_cate[1] != '') {
					this.cateChildren.findIndex((item, index) => {
						this.baseForm.good_cate[1].forEach(items => {
							if (item.cate_id == items) {
								this.tagList = [...new Set(this.tagList.concat(this.cateChildren[index]
									.tags))]
							}
						})
					})
					var arr = [];
					this.baseForm.good_cate[1].forEach(item => {
						this.tagList.forEach((item_, index_) => {
							if (item_.cate_id == item) {
								arr.push(item_)
							}
						})
					})
					this.tagList = arr;
				} else {
					this.tagList = [];
					this.baseForm.tag_ids = [];
				}
			},

			//视频音频文件存储
			saveFile(file) {
				this.imgForm.video_url_upload = file;
			},

			//视频音频文件移除
			delFile() {
				this.imgForm.video_url_upload = '';
			},

			//图片存储
			saveImg(arr) {
				switch (arr[1]) {
					case 0:
						//商品主图
						this.imgForm.cover_img = arr[0];
						break;
					case 1:
						//轮播图
						this.imgForm.wheel_img.push(arr[0]);
						break;
					case 2:
						//详情图
						this.imgForm.detail_img.push(arr[0]);
						break;
				}
			},

			//图片删除
			delImg(arr) {
				switch (arr[1]) {
					case 0:
						//商品主图
						this.imgForm.cover_img = '';
						this.coverImgList = []
						break;
					case 1:
						//轮播图
						this.imgForm.wheel_img.splice(arr[0], 1);
						break;
					case 2:
						//详情图
						this.imgForm.detail_img.splice(arr[0], 1);
						break;
				}
			},

			//表单提交
			submitForm(index) {
				if (Math.abs(index - this.tabIndex) > 1 || index == this.tabIndex) return
				if (index < this.tabIndex) {
					this.tabIndex = index;
					//移除前一页表单校验结果
					this.$refs[this.formName[this.tabIndex + 1]].clearValidate();
				} else {
					this.$refs[this.formName[index - 1]].validate((valid) => {
						if (valid) {
							if (this.tabIndex == 2) {
								let requestData = this.infoData();
								//合并所有表单
								if (this.type != -1) {
									//编辑
									goodEdit(requestData).then(res => {
										if (res.code == 0) {
											this.coverImgList = [];
											this.wheelImgList = [];
											this.$message.success(res.msg);
											this.$emit('close', 0)
										} else {
											this.$message.error(res.msg);
										}
									}).catch(err => {})
								} else {
									//新增
									goodAdd(requestData).then(res => {
										if (res.code == 0) {
											this.coverImgList = [];
											this.wheelImgList = [];
											this.$message.success(res.msg);
											this.$emit('close', 0)
										} else {
											this.$message.error(res.msg);
										}
									}).catch(err => {})
								}

							}
							if (index > 2) return
							this.tabIndex = index
						} else {
							return false;
						}
					});
				}
			},

			//数据处理
			infoData() {
				//品牌分类条目
				var brandArr = [];
				let baseForm	= {...this.baseForm};
				if (baseForm.good_brand.length > 1) {
					//多个
					const nestedArray = baseForm.good_brand;
					let mergedArray = nestedArray.reduce((acc, curr) => {
						let found = acc.find(item => item[0] === curr[0]);
						if (found) {
							found[1].push(...curr[1]);
						} else {
							acc.push([curr[0],
								[...curr[1]]
							]);
						}
						return acc;
					}, []);
					mergedArray = mergedArray.map(subArray => {
						let uniqueArray = [...new Set(subArray[1])];
						return [subArray[0], uniqueArray];
					});
					for (let i = 0; i < mergedArray.length; i++) {
						let firstElement = mergedArray[i][0];
						let secondElement = mergedArray[i][1];
						if (Array.isArray(secondElement)) {
							for (let j = 0; j < secondElement.length; j++) {
								brandArr.push([firstElement, secondElement[j]]);
							}
						} else {
							brandArr.push([firstElement, secondElement]);
						}
					}
					baseForm.good_brand = brandArr;
				} else {
					//单个
                    if(baseForm.good_brand.length){
                        if (baseForm.good_brand[0][1] != null && baseForm.good_brand[0][1].length > 0) {
                            baseForm.good_brand[0][1].forEach((item, index) => {
                                brandArr[index] = [baseForm.good_brand[0][0], item]
                            })
                        } else {
                            brandArr[0] = [baseForm.good_brand[0][0], '']
                        }
                    }
					baseForm.good_brand = brandArr;
				}

				//商品分类条目
				var cateArr = [];
				if (baseForm.good_cate[1] != null && baseForm.good_cate[1].length > 0) {
					baseForm.good_cate[1].forEach((item, index) => {
						cateArr[index] = [baseForm.good_cate[0], item]
					})
				} else {
					cateArr[0] = [baseForm.good_cate[0], '']
				}
				baseForm.good_cate = cateArr;
				return {
					...baseForm,
					...this.imgForm,
					...this.skuForm,
				}
			},

			close() {
				this.$emit('close', 1)
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
		padding: 20px 20px 0 20px;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.from_div {
		padding-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 570px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.input {
		width: 200px;
	}

	.input_s {
		width: 100px;
		margin: 0 10px;
	}

	.input_ {
		width: 435px;
	}

	.add_div {
		display: flex;
		flex-direction: column;
	}

	.item_div {
		display: flex;
		flex-direction: row;
		margin-bottom: 22px;
	}

	.select {
		width: 170px;
		margin-right: 20px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
		z-index: 9;
	}

	/* 	/deep/.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
		content: '※';
		color: #EA0000;
		font-size: 12px;
		margin-right: 4px;
	} */

	.upload_div {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 150px;
		height: 150px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		margin-right: 20px;
	}

	.el-icon-plus {
		font-size: 20px;
		font-weight: bolder;
		color: #606266;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}
</style>